import React, { FC, Suspense } from 'react';
import { USERS_ROUTES } from '@trip-ux/constants';
import { Route, Routes } from 'react-router-dom';
import { Progress } from '@trip-ux/components';
import './users.scss';
import { useSelector } from 'react-redux';
import { ReduxStore } from '@trip-ux/redux-store';
import { lazyWithChunkRetry } from '@trip-ux/common';

const UserListing = lazyWithChunkRetry(() => import('./user-listing/UserListing'));
const UserInfo = lazyWithChunkRetry(() => import('./user-info/UserInfoPage'));

export const UsersRoutes: FC<{ children?: React.ReactNode }> = () => {
  const { locale } = useSelector((store: ReduxStore) => ({
    locale: store.config.locale
  }));

  // Helper to convert absolute paths to relative paths for nested routing
  const getRelativePath = (absolutePath: string): string => {
    // Remove the base users path to get relative path for nested routing
    // return paths without a leading slash so they are relative to the parent route
    const basePath = '/users';
    const rel = absolutePath.replace(basePath, '');
    if (!rel || rel === '/') return '';
    return rel.startsWith('/') ? rel.slice(1) : rel;
  };

  return (
    <Suspense fallback={<Progress />}>
      <Routes>
        <Route path={getRelativePath(USERS_ROUTES[locale].REGISTER)} element={<UserInfo register />} />
        <Route path={getRelativePath(USERS_ROUTES[locale].INFO)} element={<UserInfo register={false} />} />
        <Route path={getRelativePath(USERS_ROUTES[locale].LISTING)} element={<UserListing />} />
        <Route index element={<UserListing />} />
      </Routes>
    </Suspense>
  );
};

UsersRoutes.displayName = 'UsersRoutes';
export default UsersRoutes;
